import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-bottombar-landing',
  templateUrl: './bottombar-landing.component.html',
  styleUrls: ['./bottombar-landing.component.scss']
})
export class BottombarLandingComponent implements OnInit {

  constructor() { }


  @Input() apiParams:any;
  @Input() bottomBarComponent:any;
  @Output() closePopUp = new EventEmitter<any>();

  ngOnInit() {
    // console.log(this.bottomBarComponent);
  }

  closeBottomBar(event){
    this.closePopUp.emit(event);
  }

}
